/* eslint-disable react/prop-types */
import React from 'react';
import {
  TimelineContainer,
  Timeline,
  TimelineContent,
  TimelineItem,
  TimelineIcon,
  Title,
  DescriptionStep
} from './ProcessTimelineStyles';

import { ReactComponent as IconCompleted } from './Icons/Timeline/IconCompleted.svg';
import { ReactComponent as IconNotCompleted } from './Icons/Timeline/IconNotCompleted.svg';

const ProcessTimeline = ({ policy }) => {
  // eslint-disable-next-line
  const showTimeline = !!policy.actionStep && policy.actionStep.steps?.length > 0;

  function transformDateFormat(inputDate) {
    const inputDateTime = new Date(inputDate);
    if (!Number.isNaN(inputDateTime.getTime())) {
      const day = inputDateTime
        .getDate()
        .toString()
        .padStart(2, '0');
      const month = (inputDateTime.getMonth() + 1).toString().padStart(2, '0');
      const year = inputDateTime.getFullYear();
      const hours = inputDateTime
        .getHours()
        .toString()
        .padStart(2, '0');
      const minutes = inputDateTime
        .getMinutes()
        .toString()
        .padStart(2, '0');

      const transformedDate = `${day}/${month}/${year} às ${hours}:${minutes}`;

      return transformedDate;
    }
    return inputDate;
  }

  function selectIcon(step) {
    if (step.completed || step.inProgress) {
      return <IconCompleted />;
    }
    return <IconNotCompleted />;
  }

  function setTimelineColorPercentage(timelineSteps) {
    const totalSteps = timelineSteps.length;
    const completedSteps = timelineSteps.filter(item => item.completed).length;
    const progressSteps = timelineSteps.filter(item => item.inProgress).length;
    const shouldNotDisplay = timelineSteps.filter(item => !item.shouldDisplay)
      .length;
    if (progressSteps === 0) {
      if (completedSteps === 0 || completedSteps === 1) return 0;
      if (completedSteps === 2)
        return (
          ((completedSteps + 1) / (2 * (totalSteps - shouldNotDisplay) - 1)) *
          100
        );
      return (
        ((2 * completedSteps - 1) / (2 * (totalSteps - shouldNotDisplay) - 1)) *
        100
      );
    }
    if (progressSteps > 0) {
      return (
        ((2 * completedSteps + 1) / (2 * (totalSteps - shouldNotDisplay) - 1)) *
        100
      );
    }
    return 0;
  }

  return (
    <>
      {showTimeline && (
        <TimelineContainer>
          <h2 className="timeline-title" style={{ fontSize: '20px;' }}>
            Status da análise
          </h2>
          <Timeline
            timelineColor={setTimelineColorPercentage(policy.actionStep.steps)}
          >
            {policy.actionStep.steps.map((step, index) =>
              step.shouldDisplay ? (
                <TimelineItem key={index}>
                  <TimelineIcon style={{ backgroundColor: '#f2f2f2' }}>
                    {selectIcon(step, index)}
                  </TimelineIcon>
                  <TimelineContent>
                    <Title>{step.title}</Title>
                    {step.timeStamp ? (
                      <DescriptionStep>
                        {transformDateFormat(step.timeStamp)}
                      </DescriptionStep>
                    ) : (
                      'Em breve'
                    )}
                  </TimelineContent>
                </TimelineItem>
              ) : (
                <></>
              )
            )}
          </Timeline>
        </TimelineContainer>
      )}
    </>
  );
};

export default ProcessTimeline;
